<div class="ppf">
  <mat-form-field appearance="outline">
    <mat-label>Fecha de nacimiento</mat-label>
    <mat-icon matPrefix class="ppf-icon">cake</mat-icon>
    <input matInput name="birthday" required autocomplete="off" placeholder="dd/mm/aaaa" [matDatepicker]="pickerBirthday" [max]="today"
           [ngModel]="birthday" (ngModelChange)="onBirthdayChange($event)">
    <mat-datepicker-toggle matSuffix [for]="pickerBirthday"></mat-datepicker-toggle>
    <mat-datepicker #pickerBirthday startView="multi-year"></mat-datepicker>
    <mat-error>Captura la fecha de nacimiento</mat-error>
  </mat-form-field>

  <div class="ppf-gender">
    <span class="ppf-gender-label">Género *</span>
    <mat-radio-group name="gender" required #genderModel="ngModel" [ngModel]="gender" (ngModelChange)="onGenderChange($event)">
      <mat-radio-button *ngFor="let g of genders" [value]="g.value">{{ g.label }}</mat-radio-button>
    </mat-radio-group>
    <span class="ppf-error" *ngIf="genderModel.invalid && genderModel.touched">Indica el género</span>
  </div>
</div>
